import { StringSchema } from 'yup';
import moment from 'moment';

export default function (this: StringSchema, message: string) {
  return this.test('cnhExpirationDate', message, function (value) {
    const dateFormat = 'DD/MM/YYYY';

    const isExperiationPlusThirtyOneDaysBeforeNow = moment(value, dateFormat).add(31, 'd').isBefore(moment());

    if (isExperiationPlusThirtyOneDaysBeforeNow) {
      return this.createError({ message: 'CNH fora do prazo de validade' });
    }

    return true;
  });
}
